import { TRANSACTION_LIST, TRANSACTION_LIST_SUCCESS, TRANSACTION_LIST_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  transactionData: null,
};

const transactionListReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TRANSACTION_LIST:
      return { ...state, loading: true };
    case TRANSACTION_LIST_SUCCESS:
      return {
        ...state,
        transactionData: action?.payload,
        loading: false,
      };
    case TRANSACTION_LIST_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default transactionListReducer;
